// extracted by mini-css-extract-plugin
export default {"ui-sm-br":"use-border-radius-module__ui-sm-br--eo5cx","ui-md-br":"use-border-radius-module__ui-md-br--ITpoz","ui-lg-br":"use-border-radius-module__ui-lg-br--fUgq3"};